import { safeDefine } from "@breuni-ui/safe-define";
import CubeRecoTracking from "../tracking/cube/CubeRecoTracking";
import AlgonomyTracking from "../tracking/algonomy/AlgonomyTracking";
import { recoCarouselContainerTagName } from "./recoCarouselContainerTagName";
import { textContentToJSON } from "../utils/textContentToJSON";
import { getRecoCarouselContainer } from "./getRecoCarouselContainer";

export type RecoCarouselContainerDependencies = {
  CubeRecoTracking: typeof CubeRecoTracking;
  AlgonomyTracking: typeof AlgonomyTracking;
  textContentToJSON: typeof textContentToJSON;
  window: typeof window;
};

export type RecoCarouselContainer = ReturnType<
  typeof getRecoCarouselContainer
> &
  HTMLElement;

safeDefine(
  recoCarouselContainerTagName,
  getRecoCarouselContainer({
    CubeRecoTracking: CubeRecoTracking,
    AlgonomyTracking: AlgonomyTracking,
    textContentToJSON: textContentToJSON,
    window: window,
  }),
);
